/*!
 * Built by Revolist
 */
import { R as RevogrScrollVirtual$1, d as defineCustomElement$1 } from './revogr-scroll-virtual2.js';

const RevogrScrollVirtual = RevogrScrollVirtual$1;
const defineCustomElement = defineCustomElement$1;

export { RevogrScrollVirtual, defineCustomElement };
